<div>
  <canvas id="PolarAreaChart"></canvas>
</div>
